// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"ShareApartmentLinksModal_buttonWrapper__XR9l2"};